import React from "react";
import { Dropdown, Button, ConfigProvider } from "antd";
import type { MenuProps } from "antd";
import { observer } from "mobx-react-lite";
import I18nService from "../services/I18nService";
import { GlobalOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";

interface FCProps {}

const LangMenu: React.FC<FCProps> = observer(({}) => {

    const [menuVisible, setMenuVisible] = React.useState(false);
    const { t } = useTranslation();

    const languages = {
      'de': {
        label: 'Deutsch (de)',
        displayLabel: 'German (de)',
      },
      'en': {
        label: 'English (en)',
        displayLabel: 'English (en)',
      }
    }

    const activeLang = I18nService.getActiveLang();

    const handleMenuVisibility = () => {
        setMenuVisible(prev => !prev);
    }

    const items: MenuProps['items'] = [
        {
          key: 'DE',
          label: (
            <div className="flex items-center gap-[4px]">
              <GlobalOutlined style={{ color: '#3498DB', fontSize: '16px' }} />
              <span style={{ color: '#00000073', fontSize: '16px', lineHeight: '24px' }}>
                {languages.de.label}
              </span>
            </div>
          ),
          onClick: () => I18nService.changeLang('de')
        },
        {
          key: 'EN',
          label: (
            <div className="flex items-center gap-[4px]">
              <GlobalOutlined style={{ color: '#3498DB', fontSize: '16px' }} />
              <span style={{ color: '#00000073', fontSize: '16px', lineHeight: '24px' }}>
                {languages.en.label}
              </span>
            </div>
          ),
          onClick: () => I18nService.changeLang('en')
        },
      ];
      
    return (
      <ConfigProvider
        theme={{
          components: {
            Button: {
              colorPrimary: 'transparent',
              colorPrimaryHover: 'transparent',
              colorPrimaryActive: 'transparent',
            }
          }
        }}>
        <Dropdown
            menu={{ items }}
            onOpenChange={handleMenuVisibility}
            open={menuVisible}
            trigger={['click']}
        >
          
            <Button
              type="text"
              className="flex items-center border-0 outline-none p-0"
              style={{ background: 'transparent' }}
            >
              <div className="flex items-center gap-[4px]">
                <GlobalOutlined 
                  style={{ 
                    color: '#3498DB',
                    fontSize: '16px' 
                  }} 
                />
                <span
                  className="md:hidden font-semibold"
                  style={{
                    color: '#00000073',
                    fontSize: '16px',
                    lineHeight: '24px'
                  }}>
                  {activeLang.toUpperCase()}
                </span>
                <span
                  className="hidden md:inline"
                  style={{
                    color: '#00000073',
                    fontSize: '16px',
                    lineHeight: '24px'
                  }}>
                  {languages[activeLang].displayLabel}
                </span>
              </div>
            </Button>
          
        </Dropdown>
      </ConfigProvider>
    );
});

export default LangMenu;